import * as StoreActions from './store.actions';
import { StoreModel } from "../../shared/interfaces";
import { CriteriaModel, EmptyCriteria } from "../../shared/interfaces/CriteriaModel";
import { EmptyPaginator, PaginatorModel } from "../../shared/interfaces/PaginatorModel";

/*Defining the state shape*/
export interface State {
	requestProcessing: boolean;
	store: StoreModel | null;
	GetStores: {
		requestProcessing: boolean;
		criteria: CriteriaModel;
		response: PaginatorModel;
	}
}

/*Setting the initial state*/
export const initialState: State = {
	requestProcessing: false,
	store: null,
	GetStores: {
		requestProcessing: false,
		criteria: EmptyCriteria,
		response: EmptyPaginator,
	}
};

/*Creating the reducer function*/
export function StoreReducer(
	state = initialState,
	action: StoreActions.Actions
): State {
	switch (action.type) {
		case StoreActions.ActionTypes.GetStoreById: {
			return {
				...state,
				requestProcessing: true,
				store: null,
			};
		}
		case StoreActions.ActionTypes.GetStoreByIdSuccess: {
			return {
				...state,
				requestProcessing: false,
				store: action.payload,
			};
		}
		case StoreActions.ActionTypes.GetStoreByIdError: {
			return {
				...state,
				requestProcessing: false,
				store: null,
			};
		}

		case StoreActions.ActionTypes.GetStores: {
			return {
				...state,
				requestProcessing: true,
				GetStores: {
					...state.GetStores,
					requestProcessing: true,
					criteria: action.payload,
				},
			};
		}
		case StoreActions.ActionTypes.GetStoresSuccess: {
			return {
				...state,
				requestProcessing: false,
				GetStores: {
					...state.GetStores,
					requestProcessing: false,
					response: action.payload,
				},
			};
		}
		case StoreActions.ActionTypes.GetStoresError: {
			return {
				...state,
				requestProcessing: false,
				GetStores: {
					...state.GetStores,
					requestProcessing: false,
				},
			};
		}

		default:
			return state;
	}
}
